
const localStorageClearByLoginOut = ()=>{
    localStorage.removeItem("token")
    localStorage.removeItem("loginUser")
    localStorage.removeItem("tokenKey")
    localStorage.removeItem("userInfo")
    localStorage.removeItem("channel")
}


export default {localStorageClearByLoginOut}